import { apiInstances } from '../../../../libs';

const { get } = apiInstances.orderInstance;

export default async function getOrdersInRoute({ filter, id_city }) {
  const result = await get(
    `/clouders/orders/in-route-to-consumer?filter=${filter}&id_city=${id_city}`
  );

  return result;
}
